import gql from "graphql-tag";

export default gql`mutation UpdateQuoteCall($id:Int!,$callid:Int!) {
    updateQuoteCall(id:$id, callid:$callid) {
        id
        call1
        call1date
        call2
        call2date
        call3
        call3date
        completed
        completeddate
    }
  }`